import Context from "../../../context/Context";
import * as aiimUtil from "../../../aiim/util/aiimUtil";
import * as queryUtil from "../../base/queryUtil";

export function collectUniqueValues(features,field,fieldName) {
  const i18n = Context.instance.i18n;
  const values = [];
  if (features) {
    features.forEach(feature => {
      const attributes = feature && feature.attributes;
      const v = aiimUtil.getAttributeValue(attributes,fieldName);
      // Should we allow nulls in the list?
      if (v !== undefined && v !== null) {
        if (values.indexOf(v) === -1) values.push(v);
      }
    })
  }
  values.sort();
  return values.map(value => {
    let name = value;
    if (value === null) {
      name = i18n.filter.nullLabel;
    } else if (typeof value === "string" && value.length === 0) {
      name = i18n.filter.emptyLabel;
    }
    return {
      name: name,
      value: value
    }
  });
}

export function getField(fields,fieldName) {
  let found;
  if (fields && fields.length > 0 && fieldName) {
    const lc = fieldName.toLowerCase();
    fields.some(field => {
      if (lc === field.name.toLowerCase()) found = field;
      return !!found;
    });
  }
  return found;
}

export function getFilterFields(source) {
  const list = [];
  const layer = source && source.layer2D;
  const fields = layer && layer.fields;
  if (fields && fields.length > 0) {
    /*
    "small-integer"|"integer"|"single"|"double"|"long"|"string"|"date"|"oid"|
    "geometry"|"blob"|"raster"|"guid"|"global-id"|"xml"
     */
    const types = ["string"];
    //types.push("small-integer","integer","long"); // TODO too many distinct values?
    //types.push("single","double"); // TODO too many distinct values?
    fields.forEach(field => {
      //console.log("getFilterFields",field.name,field.alias,field);
      if (field.domain && field.domain.type === "coded-value") {
        list.push(field);
      } else if (types.indexOf(field.type) !== -1) {
        list.push(field);
      }
    })
    list.sort((a,b) => {
      let s1 = a.alias || a.name;
      let s2 = b.alias || b.name;
      return s1.localeCompare(s2);
    });
  }
  return list;
}

export function queryUniqueValues(options) {
  const promise = new Promise((resolve,reject) => {
    let {source,field,fieldName,where} = options;
    const lib = Context.instance.lib;
    const url = Context.checkMixedContent(source.url);
    const task = new lib.esri.QueryTask({url: url});
    const query = new lib.esri.Query();
    query.returnDistinctValues = true;
    query.returnGeometry = false;
    query.returnZ = false;
    query.outFields = [fieldName];
    query.where = where || "1=1";
    queryUtil.applyGdbVersion(source,query);
    task.execute(query).then(result => {
      //console.log("queryUniqueValues",result);
      const features = result && result.features;
      const values = collectUniqueValues(features,field,fieldName);
      if (field && field.domain && field.domain.type === "coded-value") {
        //console.log("field.domain",field.domain);
        if (Array.isArray(field.domain.codedValues)) {
          const namesByCode = {};
          field.domain.codedValues.forEach(cv => {
            namesByCode[cv.code] = cv.name;
          });
          values.forEach(info => {
            let name = namesByCode[info.value];
            if (name !== null && name !== undefined) info.name = name;
          });
          values.sort((a,b) => {
            if (typeof a.name === "string" && typeof (b.name === "string")) {
              return (a.name.localeCompare(b.name));
            }
            return 0;
          });
        }
      }
      resolve(values);
    }).catch(ex => {
      reject(ex);
    })
  });
  return promise;

}
